/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Data type that has one of two possible values (usually denoted true and false)
 * @format boolean
 * @example true
 */
export type IApiBoolean = boolean;

/**
 * Minimal allowed value
 * @format integer
 * @example 123
 */
export type IApiMinAllowed = number;

/**
 * Minimal allowed value
 * @format integer
 * @example 123
 */
export type IApiMinAllowedNullable = number | null;

/**
 * Minimal allowed value
 * @format integer
 * @example 123
 */
export type IApiMinAllowedFloat = number;

/**
 * Maximum allowed value
 * @format integer
 * @example 123
 */
export type IApiMaxAllowed = number;

/**
 * Maximum allowed value
 * @format integer
 * @example 123
 */
export type IApiMaxAllowedNullable = number | null;

/**
 * Maximum allowed value
 * @format integer
 * @example 123
 */
export type IApiMaxAllowedFloat = number;

/**
 * Value represents decimal float point number
 * @format float
 * @example 123.22
 */
export type IApiNumberFloat = number;

/**
 * Value represents decimal float point number
 * @format float
 * @example 123.22
 */
export type IApiNumberFloatNullable = number | null;

/**
 * Numeric identifier
 * @format integer
 * @example 123
 */
export type IApiIdNumber = number;

/**
 * Numeric identifier
 * @format integer
 * @example 123
 */
export type IApiIdNumberNullable = number | null;

/**
 * Value represents signed integer
 * @format integer
 * @example 123
 */
export type IApiInteger = number;

/**
 * Value represents signed integer
 * @format integer
 * @example 123
 */
export type IApiIntegerNullable = number | null;

/**
 * Value represents signed integer
 * @format integer
 * @example 123
 */
export type IApiLoginInteger = number;

/**
 * String whose length can have a maximum of 64 characters
 * @format string
 * @maxLength 64
 * @example "Bonus"
 */
export type IApiString = string;

/**
 * String whose length can have a maximum of 32 characters
 * @format string
 * @maxLength 32
 * @example "String"
 */
export type IApiNameString32 = string;

/**
 * String whose length can have a maximum of 64 characters
 * @format string
 * @maxLength 64
 * @example "String"
 */
export type IApiNameString64 = string;

/**
 * Date and time in string format
 * @format string
 * @example "2015-05-16T05:50:06"
 */
export type IApiDateTimeString = string;

/**
 * Date and time in string format
 * @format string
 * @example "2015-05-16T05:50:06"
 */
export type IApiDateTimeStringNullable = string | null;

/**
 * String whose length can have a maximum of 256 characters
 * @format string
 * @maxLength 256
 * @example "Comment"
 */
export type IApiNameString256 = string;

/**
 * String whose length can have a maximum of 65000 characters
 * @format string
 * @maxLength 65536
 * @example "Comment"
 */
export type IApiNameString65K = string;

/**
 * String whose length can have a maximum of 64 characters
 * @format string
 * @maxLength 64
 * @example "USD"
 */
export type IApiCurrencyString = string;

/**
 * String whose length can have a maximum of 64 characters
 * @format string
 * @maxLength 64
 * @example "String"
 */
export type IApiTypeName = string;

/**
 * String whose length can have a maximum of 64 characters
 * @format string
 * @maxLength 64
 * @example "String"
 */
export type IApiMamCode = string;

/**
 * String whose length can have a maximum of 256 characters
 * @format string
 * @maxLength 256
 * @example "Comment"
 */
export type IApiPublicComment = string;

/**
 * String whose length can have a maximum of 65000 characters
 * @format string
 * @maxLength 65536
 * @example "Comment"
 */
export type IApiDisplayName = string;

/**
 * String whose length can have a maximum of 64 characters
 * @format string
 * @maxLength 64
 * @example "String"
 */
export type IApiMetaServerName = string;

/**
 * String whose length can have a maximum of 64 characters
 * @format string
 * @maxLength 64
 * @example "String"
 */
export type IApiMetaServerPublicName = string;

/**
 * String whose length can have a maximum of 256 characters
 * @format string
 * @maxLength 256
 * @example "Comment"
 */
export type IApiPublicCommentNullable = string | null;

/**
 * String whose length can have a maximum of 256 characters
 * @format string
 * @maxLength 256
 * @example "Comment"
 */
export type IApiLink = string;

/**
 * String whose length can have a maximum of 256 characters
 * @format string
 * @maxLength 256
 * @example "Comment"
 */
export type IApiLinkNullable = string | null;

/**
 * Email address
 * @format email
 * @maxLength 255
 * @example "adminuser@gmail.com"
 */
export type IApiEmail = string;

/**
 * User first name plus last name
 * @format email
 * @maxLength 512
 * @example "Rob Fell"
 */
export type IApiFullName = string;

/**
 * User roles delimited with comma
 * @format string
 * @example "Admin, User"
 */
export type IApiUserRoles = string;

/**
 * User status
 * @format string
 * @example "Draft"
 */
export enum IApiUserStatus {
  Draft = 'Draft',
  Approved = 'Approved',
  Declined = 'Declined',
  InProcess = 'InProcess',
  UpdateRequired = 'UpdateRequired',
  UrgentUpdate = 'UrgentUpdate',
}

/**
 * User status
 * @format string
 * @example "Balance"
 */
export enum IApiCopyType {
  Equity = 'Equity',
  Balance = 'Balance',
  Lot = 'Lot',
}

/**
 * Mam master account status
 * @format string
 * @example "Draft"
 */
export enum IApiMamMasterAccountStatus {
  Draft = 'Draft',
  InProgress = 'InProgress',
  Declined = 'Declined',
  Approved = 'Approved',
}

/**
 * The available currency in our system.
 * @format string
 * @example "USD"
 */
export enum IApiCurrency {
  USD = 'USD',
  EUR = 'EUR',
  IDR = 'IDR',
  RMB = 'RMB',
  CNY = 'CNY',
  CNH = 'CNH',
  MYR = 'MYR',
  GBP = 'GBP',
  THB = 'THB',
  VND = 'VND',
  BND = 'BND',
  BTC = 'BTC',
  USC = 'USC',
  USDT = 'USDT',
  PHP = 'PHP',
  NGN = 'NGN',
  ZAR = 'ZAR',
  INR = 'INR',
  BRL = 'BRL',
  CLP = 'CLP',
  MXN = 'MXN',
  COP = 'COP',
  PEN = 'PEN',
}

/**
 * The available trading account type in our system.
 * @format string
 * @example "Real"
 */
export enum IApiAccountType {
  Real = 'Real',
  Demo = 'Demo',
}

/**
 * The available group mapping in our system.
 * @format string
 * @example "RealStandard"
 */
export enum IApiGroupMappingType {
  RealStandard = 'RealStandard',
  RealCent = 'RealCent',
  RealStandardBonus = 'RealStandardBonus',
  RealCentBonus = 'RealCentBonus',
  RealLocalDeposit = 'RealLocalDeposit',
  RealPartner = 'RealPartner',
  RealEcn = 'RealEcn',
  RealMamMaster = 'RealMamMaster',
  RealMamInvestor = 'RealMamInvestor',
  DemoStandard = 'DemoStandard',
  DemoCent = 'DemoCent',
  Test = 'Test',
  RealMamInvestorEcn = 'RealMamInvestorEcn',
  RealSales = 'RealSales',
  RealPlus = 'RealPlus',
  RealPro = 'RealPro',
  RealCrypto = 'RealCrypto',
  RealCopyTradingMasterStandard = 'RealCopyTradingMasterStandard',
  RealCopyTradingMasterEcn = 'RealCopyTradingMasterEcn',
  RealCopyTradingInvestorStandard = 'RealCopyTradingInvestorStandard',
  RealCopyTradingInvestorEcn = 'RealCopyTradingInvestorEcn',
  DemoEcn = 'DemoEcn',
  RealCommissionStandard = 'RealCommissionStandard',
  RealCommissionEcn = 'RealCommissionEcn',
  RealMamCommissionStandard = 'RealMamCommissionStandard',
  RealMamCommissionEcn = 'RealMamCommissionEcn',
  RealMamMasterEcn = 'RealMamMasterEcn',
}

/**
 * One of available trading platform type in our system.
 * @format string
 * @example "Meta4"
 */
export enum IApiTradingPlatformType {
  Meta4 = 'Meta4',
  Meta5 = 'Meta5',
  Gmi = 'Gmi',
}

/**
 * The available allocation modes for mam account.
 * @format string
 * @example "Equity"
 */
export enum IApiAllocationMode {
  Equity = 'Equity',
  Lot = 'Lot',
}

/**
 * Localized name of country depending on current system language.
 * @format string
 * @example "Zimbabwe"
 */
export type IApiLocalisedCountry = string;

/**
 * Localized name of country depending on current system language.
 * @format string
 * @example "Zimbabwe"
 */
export type IApiLocalisedCountryNullable = string | null;

/**
 * Hashids is short, unique, non-sequential ids from numbers.
 * @format string
 * @example "e35766ae40c2df99385a9bc19210188b71e5532c"
 */
export type IApiIdHash = string;

/**
 * First Name
 * @format string
 * @minLength 1
 * @maxLength 256
 * @example "John"
 */
export type IApiFirstName = string;

/**
 * Last Name
 * @format string
 * @minLength 1
 * @maxLength 256
 * @example "Giannini"
 */
export type IApiLastName = string;

/**
 * User phone.
 * @format string
 * @minLength 1
 * @maxLength 255
 * @example "+375291234567"
 */
export type IApiPhone = string;

/**
 * User phone.
 * @format string
 * @minLength 1
 * @maxLength 255
 * @example "+375291234567"
 */
export type IApiPhoneNullable = string | null;

/**
 * Password. Validate that password is longer than or equal 8 characters and contains
 * at least one uppercase letter, one digit, any characters or symbols and less then 24 letters.
 * We doesn't allow any whitespaces in password including tabulation.
 * @format password
 * @example "MyPass1234"
 */
export type IApiPassword = string;

/**
 * Error code
 * @format string
 * @example "user.invalidCredentials"
 */
export type IApiErrorCode = string;

/**
 * Error message
 * @format string
 * @example "Invalid username adminuser@gmail.com and/or password"
 */
export type IApiErrorMessage = string;

/** Error placeholders */
export type IApiMessagePlaceholders = string[];

/** Error response */
export interface IApiErrorResponse {
  /** Error code */
  errorCode: IApiErrorCode;
  /** Error message */
  errorMessage: IApiErrorMessage;
  /** Error placeholders */
  messagePlaceholders: IApiMessagePlaceholders;
}

export interface IApiAccountSignInRequest {
  /** Email address */
  email: IApiEmail;
  /**
   * Password. Validate that password is longer than or equal 8 characters and contains
   * at least one uppercase letter, one digit, any characters or symbols and less then 24 letters.
   * We doesn't allow any whitespaces in password including tabulation.
   */
  password: IApiPassword;
}

export interface IApiAccountSignInResponse {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** Email address */
  email: IApiEmail;
  /** User roles delimited with comma */
  roles: IApiUserRoles;
  /** User status */
  status: IApiUserStatus;
  /** First Name */
  firstName: IApiFirstName;
  /** Last Name */
  lastName: IApiLastName;
  /** User phone. */
  phone: IApiPhoneNullable;
  /** Hashids is short, unique, non-sequential ids from numbers.  */
  idHash: IApiIdHash;
}

export interface IApiSettingsWithOptionalLimits {
  /** Minimal allowed value */
  minAllowed: IApiMinAllowedNullable;
  /** Maximum allowed value */
  maxAllowed: IApiMaxAllowedNullable;
}

export interface IApiTradingAccountTypeSettings {
  /** Data type that has one of two possible values (usually denoted true and false) */
  changeInvestorPasswordAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  changeLeverageAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  changeMasterPasswordAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  archivingAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  depositAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  withdrawalAllowed: IApiBoolean;
}

export type IApiLeveragesArray = IApiIdNumber[];

export interface IApiCommissionLimit {
  /** Minimal allowed value */
  minAllowed: IApiMinAllowedFloat;
  /** Maximum allowed value */
  maxAllowed: IApiMaxAllowedFloat;
}

export type IApiCommissionLimits = Record<string, IApiCommissionLimit>;

export interface IApiCopyTradingCommissionAccount {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 64 characters */
  login: IApiString;
  /** The available currency in our system. */
  currency: IApiCurrency;
}

export interface IApiDynamicDropdownViewResponse {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 64 characters */
  name: IApiNameString64;
}

export interface IApiMamSettingsResponse {
  availableAllocationMethods: IApiCopyType[];
  terminationTimeLimitSettings: IApiSettingsWithOptionalLimits;
  monthlyManagementFeeSettings: IApiSettingsWithOptionalLimits;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  limitForProfitSharing: number;
  commissionLimits: IApiCommissionLimits;
}

export interface IApiMMamUserInfo {
  /** String whose length can have a maximum of 64 characters */
  mamCode: IApiMamCode;
}

export interface IApiMamCommissionAccount {
  /** Value represents signed integer */
  login: IApiLoginInteger;
  /** Numeric identifier */
  id: IApiIdNumber;
  /** The available currency in our system. */
  currency: IApiCurrency;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
}

export interface IApiEnabledTypeForCreatingNewAccount {
  /** The available currency in our system. */
  currency: IApiCurrency;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
}

export interface IApiCommissionAccountInfoResponse {
  enabledTypesForCreatingNewAccount: IApiEnabledTypeForCreatingNewAccount[];
  createdCommissionAccounts: IApiMamCommissionAccount[];
}

export interface IApiMamMasterAccount {
  /** Value represents signed integer */
  login: IApiLoginInteger;
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 64 characters */
  typeName: IApiTypeName;
  /** The available currency in our system. */
  currency: IApiCurrency;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
}

export interface IApiMamMasterAccountDetails {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** Value represents signed integer */
  login: IApiLoginInteger;
  /** Numeric identifier */
  tradingAccountId: IApiIdNumber;
  /** Value represents signed integer */
  profitSharing: IApiInteger;
  /** Value represents decimal float point number */
  commission: IApiNumberFloatNullable;
  /** Numeric identifier */
  commissionAccountId: IApiIdNumberNullable;
  /** Value represents signed integer */
  monthlyManagementFee: IApiIntegerNullable;
  /** Value represents signed integer */
  terminationTimeInHours: IApiIntegerNullable;
  /** The available allocation modes for mam account. */
  allocationMode: IApiAllocationMode;
  /** Mam master account status */
  status: IApiMamMasterAccountStatus;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
  /** The available currency in our system. */
  currency: IApiCurrency;
  /** String whose length can have a maximum of 64 characters */
  typeName: IApiTypeName;
  /** Value represents signed integer */
  tradingAccountTypeCategoryId: IApiIntegerNullable;
  /** String whose length can have a maximum of 256 characters */
  publicComment: IApiPublicCommentNullable;
  /** String whose length can have a maximum of 256 characters */
  link: IApiLinkNullable;
}

export interface IApiCreateMamMasterAccountRequest {
  /** Value represents signed integer */
  profitSharing: IApiInteger;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  tradingAccountId?: number | null;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  typeId?: number | null;
  /** The available allocation modes for mam account. */
  allocationMode: IApiAllocationMode;
  /**
   * Value represents decimal float point number
   * @format float
   * @example 123.22
   */
  commission?: number | null;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  monthlyManagementFee?: number | null;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  tradingAccountTypeCategoryId?: number | null;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  terminationTimeInHours?: number | null;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  commissionAccountId?: number | null;
}

export interface IApiUpdateMamMasterAccountRequest {
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  commissionAccountId?: number | null;
  /** Value represents signed integer */
  profitSharing: IApiInteger;
  /** The available allocation modes for mam account. */
  allocationMode: IApiAllocationMode;
  /**
   * Value represents decimal float point number
   * @format float
   * @example 123.22
   */
  commission?: number | null;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  monthlyManagementFee?: number | null;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  tradingAccountTypeCategoryId?: number | null;
  /**
   * Value represents signed integer
   * @format integer
   * @example 123
   */
  terminationTimeInHours?: number | null;
}

export interface IApiMUserShortSummary {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** User first name plus last name */
  fullName: IApiFullName;
  /** Email address */
  email: IApiEmail;
  /** Localized name of country depending on current system language. */
  country: IApiLocalisedCountryNullable;
}

export interface IApiMUserTradingTypeCategory {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 32 characters */
  name: IApiNameString32;
  /** String whose length can have a maximum of 65000 characters */
  displayName: IApiDisplayName;
  /** Value represents signed integer */
  priority: IApiInteger;
}

export interface IApiMBaseTradingAccountType {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 64 characters */
  name: IApiNameString64;
}

export interface IApiMTradingAccount {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** Value represents signed integer */
  login: IApiLoginInteger;
  /** One of available trading platform type in our system. */
  platformType: IApiTradingPlatformType;
  /** The available trading account type in our system. */
  accountType: IApiAccountType;
  type: IApiMBaseTradingAccountType;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
  /** Value represents decimal float point number */
  minDeposit: IApiNumberFloat;
  user: IApiMUserShortSummary;
  leverages: IApiLeveragesArray;
  /** String whose length can have a maximum of 64 characters */
  currency: IApiCurrencyString;
  /** Value represents decimal float point number */
  balance: IApiNumberFloat;
  /** Value represents decimal float point number */
  margin: IApiNumberFloat;
  /** Value represents decimal float point number */
  marginFree: IApiNumberFloat;
  /** Value represents decimal float point number */
  credit: IApiNumberFloat;
  /** Value represents decimal float point number */
  equity: IApiNumberFloat;
  /** Value represents signed integer */
  leverage: IApiInteger;
  /** Data type that has one of two possible values (usually denoted true and false) */
  enabled: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isDisplay: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  readOnly: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isArchived: IApiBoolean;
  /** Date and time in string format */
  syncOn: IApiDateTimeStringNullable;
  /** Date and time in string format */
  lastDepositActionOn: IApiDateTimeStringNullable;
  settings: IApiTradingAccountTypeSettings;
  /** String whose length can have a maximum of 64 characters */
  tradingAccountName: IApiNameString64;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isShowArchiveUIWarning: IApiBoolean;
  /** Hashids is short, unique, non-sequential ids from numbers.  */
  idHash: IApiIdHash;
  /** Numeric identifier */
  investorId: IApiIdNumberNullable;
  /** Numeric identifier */
  masterId: IApiIdNumberNullable;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isMamInvestor: IApiBoolean;
  /** Date and time in string format */
  createdOn: IApiDateTimeString;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isNotificationsEnabled: IApiBoolean;
}

export interface IApiAccessServer {
  /** String whose length can have a maximum of 64 characters */
  name: IApiNameString64;
  /** String whose length can have a maximum of 256 characters */
  host: IApiNameString256;
  /** Value represents signed integer */
  port: IApiInteger;
}

export interface IApiTradingPlatformConnectionConfiguration {
  accessServers: IApiAccessServer[];
}

export interface IApiUserTradingAccountType {
  /** Numeric identifier */
  id: IApiIdNumber;
  leverages: IApiLeveragesArray;
  /** The available currency in our system. */
  currency: IApiCurrency;
  /** String whose length can have a maximum of 65000 characters */
  displayName: IApiDisplayName;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
  /** One of available trading platform type in our system. */
  tradingPlatformType: IApiTradingPlatformType;
  commissionAccounts: IApiCopyTradingCommissionAccount[];
  description: string | null;
}

export interface IApiArchivedWarningInfo {
  /** Data type that has one of two possible values (usually denoted true and false) */
  isShowArchiveUIWarning: IApiBoolean;
  /** Value represents signed integer */
  timeOfInactivity: IApiIntegerNullable;
  /** Value represents signed integer */
  archivingTime: IApiIntegerNullable;
}

export interface IApiAccountCardViewModel {
  /** The available trading account type in our system. */
  accountType: IApiAccountType;
  type: IApiMBaseTradingAccountType;
  /** Value represents decimal float point number */
  credit: IApiNumberFloat;
  /** Value represents decimal float point number */
  balance: IApiNumberFloat;
  /** String whose length can have a maximum of 64 characters */
  currency: IApiCurrencyString;
  /** Data type that has one of two possible values (usually denoted true and false) */
  enabled: IApiBoolean;
  /** Numeric identifier */
  id: IApiIdNumber;
  /** Value represents signed integer */
  leverage: IApiInteger;
  /** Value represents signed integer */
  login: IApiLoginInteger;
  /** Hashids is short, unique, non-sequential ids from numbers.  */
  idHash: IApiIdHash;
  /** One of available trading platform type in our system. */
  platformType: IApiTradingPlatformType;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isShowArchiveUIWarning: IApiBoolean;
  /** String whose length can have a maximum of 64 characters */
  tradingAccountName: IApiNameString64;
  settings: IApiTradingAccountTypeSettings;
}

export interface IApiTypeInfoViewModel {
  /** The available trading account type in our system. */
  accountType: IApiAccountType;
  /** String whose length can have a maximum of 65000 characters */
  displayName: IApiDisplayName;
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 64 characters */
  name: IApiNameString64;
  accounts: IApiAccountCardViewModel[];
  /** String whose length can have a maximum of 64 characters */
  metaServerName: IApiMetaServerName;
  /** String whose length can have a maximum of 64 characters */
  metaServerPublicName: IApiMetaServerPublicName;
}

export interface IApiMUserTradingAccountType {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 64 characters */
  name: IApiNameString64;
  /** String whose length can have a maximum of 65000 characters */
  displayName: IApiDisplayName;
  /** String whose length can have a maximum of 64 characters */
  metaServerName: IApiMetaServerName;
  /** String whose length can have a maximum of 64 characters */
  metaServerPublicName: IApiMetaServerPublicName;
  tradingPlatformConnection: IApiTradingPlatformConnectionConfiguration;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isCreationAvailable: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isNewAccountForNonApprovedAvailable: IApiBoolean;
  accounts: IApiMTradingAccount[];
  leverages: IApiLeveragesArray;
  /** The available trading account type in our system. */
  accountType: IApiAccountType;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
  /** One of available trading platform type in our system. */
  tradingPlatformType: IApiTradingPlatformType;
}

export interface IApiTradingAccountCardActions {
  /** Data type that has one of two possible values (usually denoted true and false) */
  changeInvestorPasswordAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  changeLeverageAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  changeMasterPasswordAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  archivingAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  depositAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  withdrawalAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isMamInvestor: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  pushNotificationsAllowed: IApiBoolean;
}

export interface IApiMUserTradingAccountCategory {
  category: IApiMUserTradingTypeCategory;
  types: IApiMUserTradingAccountType[];
}

export interface IApiCategoryDataViewModel {
  category: IApiMUserTradingTypeCategory;
  types: IApiTypeInfoViewModel[];
}

export interface IApiTradingAccountCardShortSettings {
  /** Data type that has one of two possible values (usually denoted true and false) */
  depositAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  withdrawAllowed: IApiBoolean;
}

export interface IApiTradingAccountCardCategory {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 64 characters */
  name: IApiNameString64;
  /** String whose length can have a maximum of 65000 characters */
  displayName: IApiDisplayName;
  /** Value represents signed integer */
  priority: IApiInteger;
}

export interface IApiTradingAccountTypeCardInfo {
  /** String whose length can have a maximum of 64 characters */
  name: IApiNameString64;
  /** String whose length can have a maximum of 65000 characters */
  displayName: IApiDisplayName;
  /** The available trading account type in our system. */
  accountType: IApiAccountType;
  /** One of available trading platform type in our system. */
  tradingPlatformType: IApiTradingPlatformType;
  /** String whose length can have a maximum of 64 characters */
  metaServerName: IApiMetaServerName;
  /** String whose length can have a maximum of 64 characters */
  metaServerPublicName: IApiMetaServerPublicName;
  /** Data type that has one of two possible values (usually denoted true and false) */
  depositAllowed: IApiBoolean;
  /** Data type that has one of two possible values (usually denoted true and false) */
  withdrawalAllowed?: IApiBoolean;
}

export interface IApiSelfTradingAccountTypeViewModel {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** String whose length can have a maximum of 64 characters */
  name: IApiNameString64;
  /** String whose length can have a maximum of 65000 characters */
  displayName: IApiDisplayName;
  description: string | null;
  tradingPlatformConnection: IApiTradingPlatformConnectionConfiguration;
  leverages: IApiLeveragesArray;
  /** The available trading account type in our system. */
  accountType: IApiAccountType;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
  /** One of available trading platform type in our system. */
  tradingPlatformType: IApiTradingPlatformType;
}

export interface IApiTradingAccountCardInfo {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** Numeric identifier */
  categoryId: IApiIdNumber;
  /** Value represents signed integer */
  login: IApiLoginInteger;
  /** Data type that has one of two possible values (usually denoted true and false) */
  enabled: IApiBoolean;
  /** Value represents signed integer */
  leverage: IApiInteger;
  /** String whose length can have a maximum of 64 characters */
  currency: IApiCurrencyString;
  /** Value represents decimal float point number */
  credit: IApiNumberFloat;
  /** Value represents decimal float point number */
  balance: IApiNumberFloat;
  /** Value represents decimal float point number */
  equity: IApiNumberFloat;
  /** String whose length can have a maximum of 64 characters */
  tradingAccountName: IApiNameString64;
  /** String */
  tradingAccountDisplayName: string;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isShowArchiveUIWarning: IApiBoolean;
  /** Hashids is short, unique, non-sequential ids from numbers.  */
  idHash: IApiIdHash;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
  type: IApiTradingAccountTypeCardInfo;
  settings: IApiTradingAccountCardShortSettings;
  archivedWarningInfo: IApiArchivedWarningInfo;
  metaServerAddress: string;
}

export interface IApiInvestorTradingAccountCardInfo {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** Numeric identifier */
  categoryId: IApiIdNumber;
  /** Value represents signed integer */
  login: IApiLoginInteger;
  /** Data type that has one of two possible values (usually denoted true and false) */
  enabled: IApiBoolean;
  /** Value represents signed integer */
  leverage: IApiInteger;
  /** String whose length can have a maximum of 64 characters */
  currency: IApiCurrencyString;
  /** Value represents decimal float point number */
  credit: IApiNumberFloat;
  /** Value represents decimal float point number */
  balance: IApiNumberFloat;
  /** Value represents decimal float point number */
  equity: IApiNumberFloat;
  /** String whose length can have a maximum of 64 characters */
  tradingAccountName: IApiNameString64;
  /** String */
  tradingAccountDisplayName: string;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isShowArchiveUIWarning: IApiBoolean;
  /** Hashids is short, unique, non-sequential ids from numbers.  */
  idHash: IApiIdHash;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
  type: IApiTradingAccountTypeCardInfo;
  settings: IApiTradingAccountCardShortSettings;
  archivedWarningInfo: IApiArchivedWarningInfo;
  investor: {
    /** User status */
    copyType: IApiCopyType;
    /** Numeric identifier */
    investorId: IApiIdNumber;
  };
  metaServerAddress: string;
}

export interface IApiMasterTradingAccountCardInfo {
  /** Numeric identifier */
  id: IApiIdNumber;
  /** Numeric identifier */
  categoryId: IApiIdNumber;
  /** Value represents signed integer */
  login: IApiLoginInteger;
  /** Data type that has one of two possible values (usually denoted true and false) */
  enabled: IApiBoolean;
  /** Value represents signed integer */
  leverage: IApiInteger;
  /** String whose length can have a maximum of 64 characters */
  currency: IApiCurrencyString;
  /** Value represents decimal float point number */
  credit: IApiNumberFloat;
  /** Value represents decimal float point number */
  balance: IApiNumberFloat;
  /** Value represents decimal float point number */
  equity: IApiNumberFloat;
  /** String whose length can have a maximum of 64 characters */
  tradingAccountName: IApiNameString64;
  /** String */
  tradingAccountDisplayName: string;
  /** Data type that has one of two possible values (usually denoted true and false) */
  isShowArchiveUIWarning: IApiBoolean;
  /** Hashids is short, unique, non-sequential ids from numbers.  */
  idHash: IApiIdHash;
  /** The available group mapping in our system. */
  groupMappingType: IApiGroupMappingType;
  type: IApiTradingAccountTypeCardInfo;
  settings: IApiTradingAccountCardShortSettings;
  archivedWarningInfo: IApiArchivedWarningInfo;
  master: {
    /** Value represents signed integer */
    commissionAccountLogin: IApiInteger;
    /** Value represents signed integer */
    profitSharing: IApiInteger;
    /** Numeric identifier */
    masterId: IApiIdNumber;
  };
  metaServerAddress: string;
}

export interface IApiCreateMasterInitialData {
  accountTypes: IApiUserTradingAccountType[];
}
